module.exports = __webpack_public_path__ + "static/media/pricing6.5750fb19.png";